export default "assets/images/rdv-6abf3d6e.svg";